module.exports = __webpack_public_path__ + "static/media/click-edit-edit-title.21d9ac43.gif";